import { useSearchParams } from "react-router-dom";
import { Box } from "@mui/material";
import { PageHeader, TabBofuV2 } from "@components/ui_v2";
import { TabBofuV2Id } from "@components/TabBofu/TabBofuV2";
import { TabEmpresa } from "@pages/producto/credito_simple/expediente/pm/TabEmpresa";
import { TabGarantia } from "@pages/producto/credito_simple/expediente/pm/TabGarantia";
import { TabPersonas } from "@pages/producto/credito_simple/expediente/pm/TabPersonas";

const VALID_PM_TABS: TabBofuV2Id[] = ["dictamen", "empresa", "garantia", "personas"];

const HEADERS: Record<TabBofuV2Id, { eyebrow: string; title: string; subtitle?: string }> = {
  dictamen: {
    eyebrow: "Expediente · Dictamen jurídico",
    title: "Validemos la estructura legal de tu empresa",
    subtitle:
      "Iniciaremos el proceso con tus actas para validar la constitución, la representación legal y los cambios estructurales relevantes.",
  },
  empresa: {
    eyebrow: "Expediente · Empresa",
    title: "Documentos de la empresa",
    subtitle:
      "Sube los documentos de tu empresa y completa la información de solicitud, información transaccional y declaraciones regulatorias.",
  },
  garantia: {
    eyebrow: "Expediente · Garantía",
    title: "Garantía",
    subtitle: "Registra los bienes o documentos que respaldarán el crédito, según los requerimientos del expediente.",
  },
  personas: {
    eyebrow: "Expediente · Personas relacionadas",
    title: "Personas relacionadas",
    subtitle:
      "Completa la información pendiente de las personas que participan en el expediente, según los roles asignados.",
  },
};

export const ExpedientePFAE = () => {
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get("tab") as TabBofuV2Id | null;
  const activeTab = tabParam && VALID_PM_TABS.includes(tabParam) ? tabParam : "empresa";
  const header = HEADERS[activeTab];

  return (
    <Box>
      <PageHeader eyebrow={header.eyebrow} title={header.title} subtitle={header.subtitle} />

      {/* TabBofuV2 debe quedar siempre montado para no interrumpir la carga del store */}
      <TabBofuV2 active={activeTab} />

      {activeTab === "empresa" && <TabEmpresa />}
      {activeTab === "garantia" && <TabGarantia />}
      {activeTab === "personas" && <TabPersonas />}
    </Box>
  );
};
